import React, { useState, useEffect, useRef } from "react"
import { Link } from "react-router-dom"
import { v4 as uuid } from "uuid"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronRight } from "@fortawesome/free-solid-svg-icons"
import { useSelector } from "react-redux"
import { selectUser } from "../Redux/userSlice"
import { Funcoes } from "../../Utils/Funcoes"

export type MenuItemProps = {
    descricao: string
    iconLeft?: JSX.Element
    iconRigth?: JSX.Element
    link: string
    SubMenuLV1?: MenuItemProps[]
    SubMenuLV2?: MenuItemProps[] // Adicionando a nova propriedade subSubMenu
    SubMenuLV3?: MenuItemProps[] // Adicionando a nova propriedade subSubMenu

    corHoverMenu?: string
    corHoverSubMenu?: string
    filtroPesquisa?: string
    id?: string

}

export const MenuItem = ({ descricao, iconLeft, iconRigth, link, SubMenuLV1, SubMenuLV2, SubMenuLV3, corHoverMenu, corHoverSubMenu, filtroPesquisa = "", id }: MenuItemProps) => {
    const [menuOpened, setMenuOpened] = useState(false)
    const [menuOpenedLv2, setMenuOpenedLv2] = useState(false)

    const [indexLv2, setIndexLv2] = useState(-1)
    const [indexLv3, setIndexLv3] = useState(-1)

    const [menuOpenedLv3, setMenuOpenedLv3] = useState(false)
    const [filteredSubMenu, setFilteredSubMenu] = useState(SubMenuLV1)

    const [expandedHeight, setExpandedHeight] = useState('h-[0px]') // variavel para expandir a altura dos itens no subMenu

    let user = useSelector(state => selectUser(state))
    let modeDark = user.modeDark
    let idMenu = uuid()
    let idSubMenu = uuid()
    
    const dadosEmpresa = Funcoes.GetDadosEmpresa()


    const toggleSubMenuLV1 = () => {

        let subMenuLv1 = document.getElementById(idMenu) as HTMLDivElement

        if (subMenuLv1) {
            let sMenu = subMenuLv1.querySelector('#s-menu-' + idMenu)

            subMenuLv1.classList.toggle("max-h-[0px]")
            subMenuLv1.classList.toggle("max-h-[1000px]")

            if (subMenuLv1.classList.contains("max-h-[1000px]")) {

                setMenuOpened(true)

            } else {
                const timer = setTimeout(() => {
                    setMenuOpened(false)
                }, 700)

                return () => clearTimeout(timer)
            }
        }
    }

    const toggleSubMenuLV2 = (id: string, index: any) => {

        let subMenuLv2 = document.getElementById(id) as HTMLDivElement
        //console.log("index2: ", index)

        if (subMenuLv2) {

            subMenuLv2.classList.toggle("max-h-[0px]")
            subMenuLv2.classList.toggle("max-h-[1000px]")

            if (subMenuLv2.classList.contains("max-h-[1000px]")) {

                setMenuOpenedLv2(true)
                setIndexLv2(index)

                const timer = setTimeout(() => {
                    setIndexLv3(-1)
                }, 10)

                return () => clearTimeout(timer)

            } else {
                const timer = setTimeout(() => {
                    setMenuOpenedLv2(false)
                }, 700)

                return () => clearTimeout(timer)

            }
        }
    }

    const toggleSubMenuLV3 = (id: string, index: any) => {

        let subMenuLv3 = document.getElementById(id) as HTMLDivElement

        if (subMenuLv3) {

            subMenuLv3.classList.toggle("max-h-[1000px]")
            subMenuLv3.classList.toggle("max-h-[0px]")

            if (subMenuLv3.classList.contains("max-h-[1000px]")) {

                setMenuOpenedLv3(true)
                setIndexLv3(index)

            } else {
                const timer = setTimeout(() => {
                    setMenuOpenedLv3(false)
                }, 700)

                return () => clearTimeout(timer)

            }
        }
    }

    const filterSubMenus = (menuItems: any) => {
        return menuItems.reduce((acc: any, item: any) => {
            // Verifica se o item atual corresponde ao filtro
            const isMatch = item.descricao.toLocaleLowerCase().startsWith(filtroPesquisa.toLocaleLowerCase());

            // Se o item corresponder, adicione ele ao array de resultados
            if (isMatch) {
                acc.push(item);
            }

            // Se o item tem SubMenuLV2, filtra também
            if (item.SubMenuLV2) {
                const filteredSubMenuLV2 = filterSubMenus(item.SubMenuLV2);
                if (filteredSubMenuLV2.length > 0) {
                    acc.push({ ...item, SubMenuLV2: filteredSubMenuLV2 });
                }
            }

            // Se o item tem SubMenuLV3, filtra também
            if (item.SubMenuLV3) {
                const filteredSubMenuLV3 = filterSubMenus(item.SubMenuLV3);
                if (filteredSubMenuLV3.length > 0) {
                    acc.push({ ...item, SubMenuLV3: filteredSubMenuLV3 });
                }
            }

            return acc;
        }, []);
    };

    useEffect(() => {
        // Filtrar o submenu com base no filtroPesquisa
        if (filtroPesquisa) {
            // Filtra o menu completo (SubMenuLV1 e seus submenus)
            const filteredItems = filterSubMenus(SubMenuLV1);
            setFilteredSubMenu(filteredItems);
            
            setMenuOpened(false)
            setIndexLv2(-1)
            setIndexLv3(-1)

        } else {
            // Se o filtro de pesquisa estiver vazio, mostrar o submenu completo
            setFilteredSubMenu(SubMenuLV1)
        }
    }, [filtroPesquisa, SubMenuLV1])

    const handleMouseUp = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement
        if (target instanceof HTMLAnchorElement) {
            target.blur()
        }
    }

    return (

        <div className={`${corHoverMenu} ${filteredSubMenu?.length || 0 > 0 ? `visible` : `hidden`} rounded-lg`}>

            <div className={`flex w-full h-[40px] cursor-pointer`} onClick={toggleSubMenuLV1}>

                <div className={`flex items-center w-8 h-full pl-2 text-white `}>
                    {iconLeft}
                </div>

                <div className={`flex items-center pl-2 w-full h-full flex-grow-1 text-white `}>
                    <span className={`text-[15px] w-full h-full flex items-center`}>{descricao}</span>
                </div>

                <div className={`flex items-center w-8 h-full text-white cursor-pointer `}>

                    {menuOpened && SubMenuLV1 && SubMenuLV1.length > 0 &&
                        <FontAwesomeIcon className={`${filtroPesquisa != "" ? 'invisible' : 'visible '}`} icon={faChevronDown} size="sm" />
                    }

                    {!menuOpened && SubMenuLV1 && SubMenuLV1.length > 0 &&
                        <FontAwesomeIcon className={`${filtroPesquisa != "" ? 'invisible' : 'visible '}`} icon={faChevronRight} size="sm" />
                    }

                </div>

            </div>

            <div id={idMenu} className={`overflow-y-hidden transition-max-height duration-[800ms] ease-in-out  ${filtroPesquisa != "" ? 'max-h-[1000px]' : `max-h-[0px]`} flex flex-col w-full items-center ${corHoverMenu} ${filteredSubMenu?.length === 0 ? 'invisible hidden ' : 'visible block '} rounded-lg `}>

                <div id={"s-menu-" + idMenu} className={`flex-col w-full`}>

                    {filteredSubMenu?.map((item, index) => {
                        let idSubMenuLV2 = index.toString().concat(uuid())
                        return (
                            <React.Fragment key={index}>

                                <div tabIndex={-1} onClick={() => toggleSubMenuLV2(idSubMenuLV2, index)} className={` ${dadosEmpresa && dadosEmpresa.id === 10 ? 'block' : dadosEmpresa && dadosEmpresa.id !== 10 && ['Empresas', 'Parceiros', 'Séries dos Doc. Fiscais'].includes(item.descricao) ? 'hidden' : 'block'} flex pl-3 ml-4 transition-all duration-300 h-[40px] items-center rounded-r-lg text-white border-l-white  ${corHoverSubMenu} border-2 border-r-0 border-t-0 border-b-0 border-opacity-70 mb-2`} >
                                    <div className={`w-auto`}>
                                        {item.iconLeft}
                                    </div>
                                    <div className="flex w-full h-full">
                                        <Link tabIndex={-1} onMouseUp={handleMouseUp} className={`ml-2 text-[12px] w-full h-full flex items-center`} to={item.link}>{item.descricao}</Link>
                                    </div>

                                    <div className={`flex items-center w-8 h-full text-white cursor-pointer`}>

                                        {menuOpenedLv2 && item.SubMenuLV2 && item.SubMenuLV2.length > 0 && index === indexLv2 &&
                                            <FontAwesomeIcon className={`${filtroPesquisa != "" ? 'invisible' : 'visible '}`} icon={faChevronDown} size="sm" />
                                        }

                                        {menuOpenedLv2 && item.SubMenuLV2 && item.SubMenuLV2.length > 0 && index != indexLv2 &&
                                            <FontAwesomeIcon className={`${filtroPesquisa != "" ? 'invisible' : 'visible '}`} icon={faChevronRight} size="sm" />
                                        }

                                        {!menuOpenedLv2 && item.SubMenuLV2 && item.SubMenuLV2.length > 0 &&
                                            <FontAwesomeIcon className={`${filtroPesquisa != "" ? 'invisible' : 'visible'}`} icon={faChevronRight} size="sm" />
                                        }

                                    </div>

                                </div>

                                <div id={idSubMenuLV2} className={`overflow-y-hidden transition-max-height  ${filtroPesquisa != "" ? `max-h-[1000px] duration-[800ms] ease-in-out` : index != indexLv2 ? `max-h-[0px] duration-[500ms] ease-out` : `max-h-[1000px] duration-[800ms] ease-in-out`} flex flex-col w-full ${corHoverMenu} ${filteredSubMenu?.length === 0 ? 'invisible hidden ' : 'visible block '} rounded-lg `}>

                                    <div id={"ss-menu-" + idSubMenuLV2} className={`flex-col w-full `}>
                                        {item.SubMenuLV2 && item.SubMenuLV2.length > 0 && (

                                            <div className={`pl-3`}>
                                                {item.SubMenuLV2.map((subItem, subIndex) => {
                                                    let idSubMenuLV3 = subIndex.toString().concat(uuid())

                                                    return (

                                                        <React.Fragment key={subIndex}>

                                                            <div tabIndex={-1} onClick={() => toggleSubMenuLV3(idSubMenuLV3, subIndex)} className={`flex pl-3 ml-4 transition-all duration-300 h-[40px] items-center rounded-r-lg text-white border-l-white  ${corHoverSubMenu} border-2 border-r-0 border-t-0 border-b-0 border-opacity-70 mb-2`} >
                                                                <div className={`w-auto`}>
                                                                    {subItem.iconLeft}
                                                                </div>
                                                                <div className={`w-full h-full flex`}>
                                                                    <Link tabIndex={-1} onMouseUp={handleMouseUp} className={`ml-2 text-[12px] w-full h-full flex items-center`} to={subItem.link}>{subItem.descricao}</Link>
                                                                </div>

                                                                <div className={`flex items-center w-8 h-full text-white cursor-pointer`}>

                                                                    {menuOpenedLv3 && subItem.SubMenuLV3 && subItem.SubMenuLV3.length > 0 && subIndex === indexLv3 &&
                                                                        <FontAwesomeIcon className={`${filtroPesquisa != "" ? 'invisible' : 'visible '}`} icon={faChevronDown} size="sm" />
                                                                    }

                                                                    {menuOpenedLv3 && subItem.SubMenuLV3 && subItem.SubMenuLV3.length > 0 && subIndex != indexLv3 &&
                                                                        <FontAwesomeIcon className={`${filtroPesquisa != "" ? 'invisible' : 'visible '}`} icon={faChevronRight} size="sm" />
                                                                    }

                                                                    {!menuOpenedLv3 && subItem.SubMenuLV3 && subItem.SubMenuLV3.length > 0 &&
                                                                        <FontAwesomeIcon className={`${filtroPesquisa != "" ? 'invisible' : 'visible'}`} icon={faChevronRight} size="sm" />
                                                                    }

                                                                </div>

                                                            </div>

                                                            <div id={idSubMenuLV3} className={`overflow-y-hidden transition-max-height ${filtroPesquisa != "" ? 'max-h-[1000px] duration-[800ms] ease-in-out' : subIndex == indexLv3 && index == indexLv2 ? `max-h-[1000px] duration-[800ms] ease-in-out` : index != indexLv2 ? `max-h-[0px] duration-[500ms] ease-out` : `max-h-[0px] ease-out`} flex flex-col w-full ${corHoverMenu} ${filteredSubMenu?.length === 0 ? 'invisible hidden ' : 'visible block '} rounded-lg`}>

                                                                {subItem.SubMenuLV3?.map((subSubItem, subSubIndex) => {
                                                                    return (
                                                                        <div id={"sss-menu-" + idSubMenuLV3} key={subSubIndex} className={`flex pl-3 ml-8 transition-all duration-300 h-[40px] items-center rounded-r-lg text-white border-l-white  ${corHoverSubMenu} border-2 border-r-0 border-t-0 border-b-0 border-opacity-70 mb-2`} >

                                                                            <div className={`w-auto`}>
                                                                                {subSubItem.iconLeft}
                                                                            </div>

                                                                            <div className={`w-full h-full flex`}>
                                                                                <Link tabIndex={-1} onMouseUp={handleMouseUp} className={`ml-2 text-[12px] w-full h-full flex items-center`} to={subSubItem.link}>{subSubItem.descricao}</Link>
                                                                            </div>

                                                                        </div>
                                                                    )

                                                                })}

                                                            </div>

                                                        </React.Fragment>

                                                    )

                                                })}
                                            </div>
                                        )}
                                    </div>

                                </div>

                            </React.Fragment>
                        )
                    })}
                </div>

            </div>

        </div>
    )
}
